import React, {PropTypes} from 'react';
import { PageHeader, Form, FormGroup, Row, Col, FormControl, Button, ControlLabel } from 'react-bootstrap';
import Logo from '../core/components/Logo'
import {Link} from 'react-router-dom';
import ToggleSwitch from '../core/components/ToggleSwitch'
import Card from '../core/Card'
import './PasswordResets.css'

class PasswordResetsContainer extends React.Component {
  state = {
    email: ""
  }

  handleChange(e) {
    var stateChange = {}
    stateChange[e.target.name] = e.target.value
    this.setState({
      ...this.state,
      ...stateChange
    })
  }

  render() {
    const errorsBox = {
        width: "100% ",
        textAlign: "center",
        color: "#d02f2f",
        marginTop: "15px"
    }
    const {isFetching, formErrorMessage, title, handleOnSubmit} = this.props
    const {email} = this.state
    return (
      <div className="PasswordResets">
        <Card>
          <Form className="credentials-form" onSubmit={(event)=>{
            event.preventDefault()
            !isFetching && handleOnSubmit(this.state.email).then(()=>{
              this.setState({email: ''})
            })
          }} horizontal>
            <Logo />

            <FormGroup controlId="formTitle">
             <Col sm={12}>
               <h3 className="form-title">{title}</h3>
             </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalEmail">
             <Col sm={12}>
               <FormControl className="input-lg" type="email" name="email"
                 value={email} placeholder="Email"
                 onChange={this.handleChange.bind(this)} />

             </Col>
            </FormGroup>

            <FormGroup>
             <Col sm={12}>
               <Button disabled={isFetching} className="btn-main-green" bsSize="large" type="submit" >
                {isFetching ? "Sending..." : "Send Reset Instructions"}
               </Button>

               <div style={errorsBox}>
                 {formErrorMessage}
               </div>
             </Col>

           </FormGroup>

          </Form>
        </Card>
      </div>

    )
  }
}

export default PasswordResetsContainer



// WEBPACK FOOTER //
// ./src/user/PasswordResetsContainer.js